import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useWorkingTimeStore } from '@nsftx/seven-client-retail-vue-dm'
import { useIntegrator } from '@nsftx/seven-client-retail-vue-integrator'
import { logService } from '@nsftx/seven-client-retail-utils'

const LOG_PREFIX = '[integratorSSBTBettingService]'

let workingTimeValidationTimeout: number | undefined

const init = () => {
  watchWorkingTimeValidity()
}

const validateBettingAvailability = () => {
  const { denyBetting, allowBetting } = useIntegrator()
  const { isValid, scheduleTime } = useWorkingTimeStore().isWorkingTimeValid()

  if (!isValid) {
    denyBetting()
    logService.warn(`${LOG_PREFIX} Betting is denied.`, {
      code: 'ST_INTEGRATOR_BETTING_DENIED'
    })
    return
  }

  allowBetting()
  logService.debug(`${LOG_PREFIX} Betting is allowed.`, {
    code: 'ST_INTEGRATOR_BETTING_ALLOWED'
  })

  if (workingTimeValidationTimeout) {
    clearTimeout(workingTimeValidationTimeout)
  }

  workingTimeValidationTimeout = window.setTimeout(validateBettingAvailability, scheduleTime)
}

const watchWorkingTimeValidity = () => {
  const { workingTimeData } = storeToRefs(useWorkingTimeStore())

  watch(workingTimeData, validateBettingAvailability, { immediate: true })
}

export default { init }
